import React from 'react'
import Edit from '../crud/edit'
import fields from './fields'
import menuItems from './menuItems'

const EditBuddyMatch = props => {
  return (
    <Edit
      title='Edit Buddy Request'
      fields={fields}
      apiPath={`admin/buddy_requests/${props.params.buddyRequestId}`}
      successRedirectPath='/security/buddy-requests'
      buildMenuItems={menuItems}
    />
  )
}

export default EditBuddyMatch
